export default __webpack_public_path__ + "9b941c9ee9b5c6058e75267e7891dc8b.svg";